import React from 'react';
import clsx from 'clsx';

import styles from './Avatar.scss';

interface Props {
  firstName: string;
  lastName: string;
  className: string;
  textClassName: string;
}

const Avatar = ({ firstName, lastName, className, textClassName }: Props) => {
  const firstNameLetter = firstName ? firstName[0] : '';
  const lastNameLetter = lastName ? lastName[0] : '';

  return (
    <div
      className={clsx(styles.container, className)}
      data-testid="PlatformAdminUI-UsersLink-Avatar-UserAvatar"
    >
      <div
        className={clsx(styles.innerContainer, textClassName)}
        data-testid="PlatformAdminUI-UsersLink-Avatar-UserAvatarText"
      >
        {firstNameLetter + lastNameLetter}
      </div>
    </div>
  );
};

export default Avatar;
